import { Select, Option, OptionGroup } from '@/ui-components/atoms/Inputs/Select';
import { getGenreList } from './genres';
import { ChannelGuideTaxonomy } from './interfaces';
import styles from './channelGuide.module.scss';

const { selectorStyles, selectOption } = styles;

type Option = {
    value: string;
    label: string;
};

function getLabelByValue(list: Option[], selectedValue: string) {
    const listItem = list.find((item) => item.value === selectedValue);

    return listItem ? listItem.label : '';
}

interface GenreSelectorProps {
    bodyComponent: string;
    genre: string;
    label: string;
    taxonomy?: ChannelGuideTaxonomy;
    hasXtraChannels?: boolean;
    setGenre: (value: string) => void;
    setLabel: (value: string) => void;
}

export default function GenreSelector({
    bodyComponent,
    genre,
    label,
    taxonomy,
    hasXtraChannels,
    setGenre,
    setLabel,
}: GenreSelectorProps) {
    const genreList = getGenreList(bodyComponent, taxonomy, hasXtraChannels) || [];

    return genreList?.length > 0 ? (
        <Select
            type="dropdown"
            label="Genre"
            theme="grayLightWeb2"
            value={genre}
            placeholder={genre === 'All' && bodyComponent !== 'All' ? genreList[0]?.label : label}
            name="Genres"
            onChange={(e) => {
                setGenre(e.value);
                setLabel(getLabelByValue(genreList, e.value));
            }}
            dataCy="channel-guide-genre-select"
            className={selectorStyles}
            selectHeader={{ title: 'Select a genre', body: null }}
        >
            <OptionGroup>
                {genreList.map((genreOption, i) => {
                    if (genreOption.label) {
                        return (
                            <Option key={i} value={genreOption.value} className={selectOption}>
                                {genreOption.label}
                            </Option>
                        );
                    }

                    return <></>;
                })}
            </OptionGroup>
        </Select>
    ) : null;
}
